export default __webpack_public_path__ + "static/media/seasonLogo.062a838a.svg";